import { createRecipeSlug } from "base/utils";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import logo from "../../images/BlogFreeRecipe-drkBkgrd.png";
import PageDivider from "base/PageDivider";
import React, { useMemo, useState } from "react";
import RecipeBadgeDetails from "./RecipeBadgeDetails";
import RecipeCollapsed from "./RecipeCollapsed";
import RecipeDirections from "./RecipeDirections";
import RecipeIngredientLinkCard from "./RecipeIngredientLinkCard";
import RecipeIngredientToolTab from "./RecipeIngredientToolTab";
import RecipeKitchenToolLinkCard from "./RecipeKitchenToolLinkCard";
import RecipeServingInfo from "./RecipeServingInfo";
import RecipeTiming from "./RecipeTiming";

const createRecipeUrl = (recipe) => {
  const slug = createRecipeSlug(recipe);
  return slug ? `/recipes/${slug}` : `/recipeDetails/${recipe?.id}`;
};

const RecipeCard = ({ recipe, isExpanded, emitToggle }) => {
  const [servings, setServings] = useState(recipe.num_of_servings ?? null);
  React.useEffect(() => {
    setServings(recipe.num_of_servings ?? null);
  }, [recipe.id, recipe.num_of_servings]);

  const handleToggle = () => {
    emitToggle(recipe.id);
  };

  const mainPicture = useMemo(() => {
    return recipe.main_picture || recipe.additional_pictures?.[0] || logo;
  }, [recipe]);
  const recipeUrl = useMemo(() => {
    return createRecipeUrl(recipe);
  }, [recipe]);

  const onItemNeeded = (e) => {
    let itemLocation = "#" + e.split(" ").pop();
    window.location.href = `${itemLocation}`;
  };

  return (
    <div
      className={`Recipe-Card p1 ${
        !isExpanded ? "Card-Collapsed" : "Card-Expanded"
      }`}
    >
      <>
        {recipe.status == "pending_approval" ? (
          <div className="Pending-Recipe">Pending</div>
        ) : (
          <></>
        )}
        {!isExpanded ? (
          <div className="Row Space-B">
            <RecipeCollapsed
              recipe={recipe}
              badges={recipe.badges}
              handleToggle={handleToggle}
            />
          </div>
        ) : (
          <div id="top" className="Expanded-Container">
            <button className="Dark-Gray Collapse-Arrow" onClick={handleToggle}>
              {window.innerWidth > 600 ? (
                <svg
                  className="w-6 h-6 text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 9h4m0 0V5m0 4L4 4m15 5h-4m0 0V5m0 4 5-5M5 15h4m0 0v4m0-4-5 5m15-5h-4m0 0v4m0-4 5 5"
                  />
                </svg>
              ) : (
                <FontAwesomeIcon icon={faArrowUp} />
              )}
            </button>

            <h3 className="Recipe-Preview-Title Row">
              <Link to={recipeUrl}>
                <span className="Width-16">{recipe.recipe_name}</span>
              </Link>
            </h3>

            <div className="Justify-Center">
              <img
                alt={`${recipe.recipe_name} main image`}
                src={mainPicture}
                className="Large-Logo"
              />
            </div>

            <RecipeTiming recipe={recipe} />
            <PageDivider />

            <div className="p1">
              <RecipeServingInfo
                recipe={recipe}
                servings={servings}
                setServings={setServings}
              />
              <RecipeBadgeDetails badges={recipe.badges} />
            </div>
            <PageDivider />

            <RecipeIngredientToolTab
              recipe={recipe}
              itemNeeded={onItemNeeded}
              servings={servings}
            />
            <PageDivider />

            <RecipeDirections recipe={recipe} />
            {/* {amazonLinkStatus && (
              <>
                <PageDivider />
                <section id="Ingredient" className="Linked-Sections">
                  <h4 className="Linked-Titles">Purchase Ingredients</h4>
                  <RecipeIngredientLinkCard ingredients={recipe.ingredients} />
                  <h6 className="Disclaimer-Text">
                    Please note: the ingredients in this section are
                    suggestions, and may not be the exact product used by the
                    recipe's author.
                  </h6>
                </section>
                <PageDivider />
                <section id="Tool" className="Linked-Sections">
                  <h4 className="Linked-Titles">Purchase Kitchen Tools</h4>
                  <RecipeKitchenToolLinkCard
                    kitchenTools={recipe.kitchen_tools}
                  />
                  <h6 className="Disclaimer-Text">
                    Please note: the kitchen tools in this section are
                    suggestions, and may not be the exact product used by the
                    recipe's author.
                  </h6>
                </section>
              </>
            )} */}
            <a href="#top" className="Row marg-1 Justify-Center Green">
              <h6 className="Small-Font">Top of Recipe</h6>
            </a>
          </div>
        )}{" "}
      </>
    </div>
  );
};

export default RecipeCard;
